import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './OrderSummary.css';
import BASE_URL from '../config';

const OrderSummary = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/ordersummary/${orderId}/`);
        setOrder(response.data);
      } catch (error) {
        console.error('Error fetching order details:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [orderId]);

  if (loading) return <div className="order-loading">Loading...</div>;
  if (!order) return <div className="order-loading">No order found.</div>;

  return (
    <div className="order-page">
      {/* Success banner */}
      <div className="order-success">
        <div className="order-success-icon">✓</div>
        <h1>Order Confirmed</h1>
        <p className="order-success-sub">Thank you for your order!</p>
      </div>

      <div className="order-grid">
        {/* Left column — Order details */}
        <div>
          <div className="order-section">
            <h2 className="order-section-title">Order Details</h2>
            <div className="order-info-card">
              <div className="order-info-row">
                <span className="order-info-label">Order ID</span>
                <span className="order-info-value">{order.order_number}</span>
              </div>
              <div className="order-info-row">
                <span className="order-info-label">Status</span>
                <span className="order-info-value">
                  <span className="order-status-badge">{order.order_status}</span>
                </span>
              </div>
              <div className="order-info-row">
                <span className="order-info-label">Payment method</span>
                <span className="order-info-value">{order.payment_method}</span>
              </div>
              <div className="order-info-row">
                <span className="order-info-label">Delivery date</span>
                <span className="order-info-value">{order.delivery_date}</span>
              </div>
              <div className="order-info-row">
                <span className="order-info-label">Delivery time</span>
                <span className="order-info-value">{order.delivery_time}</span>
              </div>
              <div className="order-info-row">
                <span className="order-info-label">Shipping address</span>
                <span className="order-info-value">
                  {order.shipping_address.address_line1}<br />
                  {order.shipping_address.city}, {order.shipping_address.country}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Right column — Ordered items */}
        <div>
          <div className="order-section">
            <h2 className="order-section-title">Ordered Items</h2>
            <div className="order-items-card">
              <div className="order-items-header">
                <span className="order-items-col">Item</span>
                <span className="order-items-col center">Price</span>
                <span className="order-items-col center">Qty</span>
                <span className="order-items-col right">Total</span>
              </div>
              {order.items.map((item, idx) => (
                <div className="order-item-row" key={idx}>
                  <span className="order-item-name">{item.item_title}</span>
                  <span className="order-item-price">CHF {parseFloat(item.price).toFixed(2)}</span>
                  <span className="order-item-qty">{item.quantity}</span>
                  <span className="order-item-total">CHF {(item.quantity * item.price).toFixed(2)}</span>
                </div>
              ))}
              <div className="order-grand-total">
                <span className="order-grand-label">Total</span>
                <span className="order-grand-value">CHF {parseFloat(order.total).toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="order-continue">
        <a href="/products" className="order-continue-link">Continue Shopping</a>
      </div>
    </div>
  );
};

export default OrderSummary;
